<template>
<section class="container" v-show="currentForm">
    <section class="form-container">
        <div class="title">{{currentForm.name}}</div>
        <div class="description">{{currentForm.description}}</div>
        <ul class="form-list">
            <li class="form-item" v-for="(item, index) in formList">
                <div class="notesbg" v-if="index === bgIndex">
                  <p class="notes">{{item.notes}}</p>
                  <img src="../../assets/images/notes-bg.png" alt="">
                </div>
                <component :is="item.formType" :transProp="item" @input="checkBgIndex" :index="index" ref="collectOptions"></component>
            </li>
        </ul>
        <div class="form-submit" @click="submit">
            <img src="../../assets/images/form-submit.png" alt="">
        </div>
    </section>
    <van-loading v-show="submitLoading"/>
    <submit-succeed v-model="showSucceed" v-if="showSucceed"></submit-succeed>
</section>
</template>

<script>
import fetchData from "@/utils/fetch";
import { Loading, Dialog } from 'vant';
import formRadio from "./formRadio";
import formInput from "./formInput";
import formEmail from "./formEmail";
import formBank from "./formBank";
import formUpload from "./formUpload";
import formSelect from "./formSelect";
import formCalendar from "./formCalendar";
import formTextArea from "./formTextArea";
import formAddress from "./formAddress";
import formTime from "./formTime";
import submitSucceed from './submitSucceed';
export default {
  data() {
    return {
      fkey: this.$route.query.fkey,
      formList: [],
      currentForm: "",
      bankCode: "",
      bgIndex: null,
      origin_tasknum: this.$route.query.num,
      showSucceed: false,
      submitLoading: false,
      typesToForm: new Map([
        ["text_field", formInput],
        ["bank_field", formBank],
        ["attachment_field", formUpload],
        ["address_field", formAddress],
        ["text_area", formTextArea],
        ["radio_button", formRadio],
        ["idcards_field", formInput],
        ["date_field", formCalendar],
        ["time_field", formTime],
        ["email_field", formEmail],
        ["mobile_field", formInput],
        ["page_break", formInput]
      ]),
      input: {
        index: 1,
        title: "测试标题",
        tip: "&小说明打听个人的好的发表"
      },
      radio: {
        index: 2,
        title: "哈哈"
      }
    };
  },
  components: {
    formRadio,
    formInput,
    submitSucceed,
    'van-loading': Loading
  },
  created() {
    this.initForms();
  },
  methods: {
    initForms() {
      fetchData("getFormDetail", {
        fkey: this.fkey
      })
        .then(({ data }) => {
          if (data && !Object.keys(data).length) {
            Dialog.alert({
              message: '抱歉此表单已停运，请到首页重新查看'
            }).then(() => {
              this.$router.go(-2);
              // on close
            });
            return;
          }
          this.currentForm = data;
          this.formList = this.handleAllTypes(data.fields);
        })
        .catch(err => {});
    },
    checkBgIndex(index) {
      if (this.bgIndex === index) {
        this.bgIndex = null;
        return;
      }
      this.bgIndex = index;
    },
    handleAllTypes(list) {
      let banktype = list.find(i => i.type === "bank_field");
      if (banktype) {
        banktype.label = "银行卡号";
        banktype.coded = "number";
        this.bankCode = banktype.code;
        this.createNewFormItem({
          list,
          label: "银行名称",
          coded: "name",
          originalObj: banktype,
          type: "bank_field",
          num: 1
        });
        if (banktype.open_style === "1") {
          this.createNewFormItem({
            list,
            label: "归属地",
            coded: "ownership",
            originalObj: banktype,
            type: "bank_field",
            num: 2
          });
          this.createNewFormItem({
            list,
            label: "开户行",
            coded: "open",
            originalObj: banktype,
            type: "bank_field",
            num: 3
          });
        }
      }
      list.forEach(i => {
        i.formType = this.typesToForm.get(i.type);
        i.required = i.validations.presence === '1' ? true : false;
        if (i.type === 'mobile_field' && i.required) {
          i.rules = {
            pattern: /1[^01]\d{9}/,
            message: '请输入正确的手机号',
          }
        }
        if (i.type === 'idcards_field' && i.required) {
          i.rules = {
            pattern: /(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: '请输入正确的身份证格式',
          }
        }
        if (i.type === 'email_field' && i.required) {
          let reg = /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/
          i.rules = {
              pattern: reg,
              message: '请输入正确的邮箱格式',
          }
        }
      });
      return list;
    },
    createNewFormItem(opts = {}) {
      const { list, originalObj, label, coded, type, num } = opts;
      const originalCopy = Object.assign({}, originalObj);
      originalCopy.label = label;
      originalCopy.coded = coded;
      const index = list.findIndex(item => item.type === type);
      // if (type === 'address_field') {
      //     originalCopy.type = 'text_field'
      // }
      list.splice(index + num, 0, originalCopy);
    },
    validateAll() {
      let regs = [];
      this.$refs.collectOptions.forEach(item => {
        let va = item.validate();
        regs.push(va.boo)
      })
      if (regs.includes(true)) {
        return false
      }
      return true;
    },
    submit() {
      if ((!this.validateAll())||this.submitLoading) return;
      const params = new URLSearchParams(location.search);
      this.submitLoading = true;
      let gameHallFormOptions = JSON.parse(window.sessionStorage.getItem('gameHallFormOptions'));
      let options = {fkey: this.fkey, ...gameHallFormOptions};
      this.$refs.collectOptions.forEach(item => {
        let o = item.collectOptions();
        options[o.code] = o.value;
      });
      if (this.bankCode) {
        options[this.bankCode] = {
          number: options.number,
          name: options.name,
          ownership: options.ownership,
          open: options.open,
        }
      }
      if (this.origin_tasknum) options.origin_tasknum = this.origin_tasknum;
      let qucParams = ['qid', 'timestamp', 'src', 'ukey'];
      qucParams.forEach(item => {
          let param = params.get(item);
          if (param) {
              options[item] = param;
          }
      })
      fetchData('submitForm', options).then((result) => {
        if (result) {
          this.showSucceed = true;
        }
      }).catch((err) => {
        
      }).finally(_ => {
        this.submitLoading = false;
      })
    }
  }
};
</script>

<style>
.icon-required {
  color: #f5222d;
}
.van-loading {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: black;
  opacity: 0.6;
  padding: 20px;
}
.form-error {
  color: #f5222d;
  /* font-size: 24px; */
  margin-top: 10px;
}
</style>
<style lang="scss" scoped>
.container {
  background: #f4f4f4;
  padding: 0 32px;
  min-height: calc(100vh - 100px);

  .form-container {
    background: white;
    padding: 0 48px 200px;
    min-height: calc(100vh - 100px);
    overflow: hidden;

    .title {
      margin-top: 80px;
      margin-bottom: 36px;
      text-align: center;
      font-weight: bold;
    }

    .description {
      color: #666;
      font-size: 24px;
      margin-bottom: 60px;
      line-height: 36px;
    }

    .form-list {
      .form-item {
        margin-bottom: 60px;
        position: relative;
        .notesbg {
          width: 404px;
          height: 156px;
          position: absolute;
          right: 0;
          top: -156px;
          .notes {
            color: white;
            position: absolute;
            padding: 20px;
            left: 0;
            top: 0;
            font-size: 24px;
          }
        }
      }
    }

    .form-submit {
      margin-top: 76px;
      height: 64px;
    }
  }
}
</style>
